import { money } from "@/pages/documents/components/DocumentWorkspace";
import type { FilteredInvoiceTotals } from "../invoice-calculations";

interface InvoiceFilteredTotalsProps {
  totals: FilteredInvoiceTotals;
  loading: boolean;
}

export function InvoiceFilteredTotals({ totals, loading }: InvoiceFilteredTotalsProps) {
  if (loading) return null;

  const items = [
    { label: "Factures émises", value: String(totals.count) },
    { label: "Total facturé", value: money(totals.invoiced) },
    { label: "Déjà encaissé", value: money(totals.paid) },
    { label: "Reste à encaisser", value: money(totals.remaining), emphasis: true },
  ];

  return (
    <div className="mb-3 grid grid-cols-2 gap-2 rounded-lg border border-border bg-card p-3 sm:grid-cols-4">
      {items.map((item) => (
        <div key={item.label}>
          <div className="text-[11px] text-subtle">{item.label}</div>
          <div className={item.emphasis ? "text-[15px] font-bold text-foreground" : "text-[14px] font-semibold text-foreground"}>
            {item.value}
          </div>
        </div>
      ))}
    </div>
  );
}
